import axios from "axios";
import { APP_BASE_URL, GET_ASSET_FORM, GET_COLLECTION_MAP_ID } from "../../../../Common/EndPoints";

const SIGNAL_INFO_FORM_TO_KEY = {
  aspect: "77a3eafd-0392-4764-8ee1-da5e4ec48572",
  connected_routes: "335dae9d-41b6-43dc-a588-df3e36c89b19",
  connected_calling: "2096b762-4796-4ede-a903-c301291ec4f3",
};

export async function getSignalInformation(device_id: string, pm_gear_typeid: string) {
  const collection_map_url = `${APP_BASE_URL}${GET_COLLECTION_MAP_ID}?type_id=${pm_gear_typeid}`;
  const collection_map = await axios.get(collection_map_url);
  const collection_map_id = collection_map?.data?.[0].collectionmapid;

  const form_url = `${APP_BASE_URL}${GET_ASSET_FORM}?collection_map_id=${collection_map_id}&with_responses=true&device_id=${device_id}`;
  const form_list_raw = await axios.get(form_url);
  const form_list = form_list_raw.data.data;

  for (const form of form_list) {
    if (form.name === "SIGNAL_INFORMATION") {
      const data = form.responses[0].data;
      const connected_routes = data[SIGNAL_INFO_FORM_TO_KEY.connected_routes]?.trim()?.split(",") ?? [];
      const connected_calling = data[SIGNAL_INFO_FORM_TO_KEY.connected_calling]?.trim()?.split(",") ?? [];
      return {
        aspect: data[SIGNAL_INFO_FORM_TO_KEY.aspect],
        connected_route_name_list: connected_routes,
        connected_calling_name_list: connected_calling,
      };
    }
  }

  throw new Error("Information not available for this Signal");
}
